import React from 'react';
import { withNamespaces } from 'react-i18next';

class Prelude extends React.Component {
    render() {
        return (
            <div className="homePageContainer">
                <div className="homeText">
                    <div className="homeTextInnerWrapper">
                        <div className="homeTextInner">
                            <div className="homeTextActualText">
                            <h2>École secondaire Le Prélude</h2>
                                <div className="detailsHeader">
                                <div className="subBlock1">
                                    
                                    <h3>{this.props.t("Statistics")}</h3>
                                    <p>{this.props.t("Number of teachers")} 65</p>
                                    <p>{this.props.t("Number of students")} 1040</p>
                                    <p>{this.props.t("International students")} 0.1%</p>
                                    <p>{this.props.t("School uniform")} {this.props.t("Required")}</p>
                                    <p>{this.props.t("Grades")} {this.props.t("7-11")}</p>
                                    <p>{this.props.t("Founded")} 1991</p>
                                </div>
                                <div className="subBlock2">
                                <img src="/images/prelude1.jpg" alt="city" />
                                <img src="/images/prelude2.jpg" alt="city" />
                                </div>
                                </div>

                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Programs")}</h2>
                                    <span>{this.props.t("Regular Academic...")}</span>
                                </div>
                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Sports Activities")}</h2>
                                    <span>{this.props.t("Basketball, Soccer, Volleyball, Badminton, Hockey, Etc.")}</span>
                                </div>
                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Club Activities")}</h2>
                                    <span>{this.props.t("Orchestra, Dance, Science Fair, Chess Club, Scrap-booking Club, Cheerleading, Environment Club, Year Book, Etc.")}</span>
                                </div>
              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withNamespaces()(Prelude);